module.exports = __webpack_public_path__ + "static/media/St_VS_BnH_N.f900f4bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/St_VS_BnH_N.png
// module id = 91
// module chunks = 0